/*
用来在内存中存储数据
 */
export default{
   company_info:{
      company_account:""
   } //保存当前登录的用户信息
}